__turbopack_context__.v({
  "container": "mochi-carousel-module-scss-module__xDAE1W__container",
  "icon-container": "mochi-carousel-module-scss-module__xDAE1W__icon-container",
  "next-icon-container": "mochi-carousel-module-scss-module__xDAE1W__next-icon-container",
  "prev-icon-container": "mochi-carousel-module-scss-module__xDAE1W__prev-icon-container",
  "swiper-container": "mochi-carousel-module-scss-module__xDAE1W__swiper-container",
  "swiper-image": "mochi-carousel-module-scss-module__xDAE1W__swiper-image",
});
